<form
  #form="ngForm"
  novalidate
  class="flex flex-col gap-1"
>
  @let vm = offshoreReportStore.vm();
  @let store = offshorePositionAndWeatherStore;
  <h1 class="mb-4 self-center text-xl">Wind</h1>

  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'apparentWindSpeed')"
    id="apparentWindSpeed"
    name="apparentWindSpeed"
    label="Apparent Wind Speed"
    [required]="true"
    [unit]="units.metersPerSecond"
    [labelWidthPercentage]="33"
    [required]="
      vm.isFieldRequired(tabId, sectionId, 'apparentWindSpeed') &&
      !store.vm().isTrueWindReporting
    "
    [readonly]="store.vm().isTrueWindReporting"
    [min]="0"
    [value]="store.wind().apparentWindSpeed.value"
    [ngModel]="store.wind().apparentWindSpeed.value"
  />
  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'apparentWindDirection')"
    id="apparentWindDirection"
    name="apparentWindDirection"
    label="Apparent Wind Direction"
    [required]="true"
    [unit]="units.degrees"
    [labelWidthPercentage]="33"
    [required]="
      vm.isFieldRequired(tabId, sectionId, 'apparentWindDirection') &&
      !store.vm().isTrueWindReporting
    "
    [readonly]="store.vm().isTrueWindReporting"
    [min]="0"
    [value]="store.wind().apparentWindDirection.value"
    [ngModel]="store.wind().apparentWindDirection.value"
  />

  <nsp-checkbox-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'trueWindReporting')"
    class="h-10.5 place-content-center"
    id="trueWindReporting"
    name="trueWindReporting"
    label="True Wind Reporting"
    [labelWidthPercentage]="33"
    [value]="store.wind().trueWindReporting.value"
    [ngModel]="store.wind().trueWindReporting.value"
  />
  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'trueWindSpeed')"
    id="trueWindSpeed"
    name="trueWindSpeed"
    label="True Wind Speed"
    [unit]="'m/s'"
    [labelWidthPercentage]="33"
    [required]="
      vm.isFieldRequired(tabId, sectionId, 'trueWindSpeed') &&
      store.vm().isTrueWindReporting
    "
    [readonly]="!store.vm().isTrueWindReporting"
    [min]="0"
    [value]="store.wind().trueWindSpeed.value"
    [ngModel]="store.wind().trueWindSpeed.value"
  />
  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'trueWindDirection')"
    id="trueWindDirection"
    name="trueWindDirection"
    label="True Wind Direction"
    [unit]="units.degrees"
    [labelWidthPercentage]="33"
    [required]="
      vm.isFieldRequired(tabId, sectionId, 'trueWindDirection') &&
      store.vm().isTrueWindReporting
    "
    [readonly]="!store.vm().isTrueWindReporting"
    [min]="0"
    [value]="store.wind().trueWindDirection.value"
    [ngModel]="store.wind().trueWindDirection.value"
  />
  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'trueWindForce')"
    id="trueWindForce"
    name="trueWindForce"
    label="True Wind Force (BF)"
    [unit]="units.degrees"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'trueWindForce')"
    [readonly]="true"
    [min]="0"
    [value]="store.vm().trueWindForce"
    [ngModel]="store.vm().trueWindForce"
  />
  <nsp-number-input
    *nspVisible="
      vm.isFieldVisible(tabId, sectionId, 'trueWindDirectionTrueNorth')
    "
    id="trueWindDirectionTrueNorth"
    name="trueWindDirectionTrueNorth"
    label="True Wind Direction (True North)"
    [unit]="units.degrees"
    [labelWidthPercentage]="33"
    [required]="
      vm.isFieldRequired(tabId, sectionId, 'trueWindDirectionTrueNorth')
    "
    [readonly]="true"
    [min]="0"
    [value]="store.vm().trueWindDirection"
    [ngModel]="store.vm().trueWindDirection"
  />
</form>
